// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"258":"4dfa2e3f2030ae9f","888":"fcc807bc541a7b22"}[chunkId] + ".css";
};